The scheme ID of the suggested application questions.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
